module.exports = __webpack_public_path__ + "img/success.b215e45c.svg";